module.exports = __webpack_public_path__ + "static/SURVIVANT-2-720p-c5a5a1765c4d140bfbde16e7c8d03c59.mp4";